// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"345":"ad05568d","813":"ad05568d"}[chunkId] + ".chunk.css";
};